import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import AgeGate from "@/components/AgeGate";
import MetaPixel from "@/components/MetaPixel";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Collections from "@/pages/Collections";
import Gifts from "@/pages/Gifts";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const withLayout = (Component) => (
  <Layout>
    <Component />
  </Layout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AgeGate />
            <MetaPixel />
            <Routes>
              <Route path="/" element={withLayout(Home)} />
              <Route path="/shop" element={withLayout(Shop)} />
              <Route path="/collections" element={withLayout(Collections)} />
              <Route path="/gifts" element={withLayout(Gifts)} />
              <Route path="/about" element={withLayout(About)} />
              <Route path="/contact" element={withLayout(Contact)} />
              <Route path="/product/:id" element={withLayout(ProductDetail)} />
              <Route path="/cart" element={withLayout(Cart)} />
              <Route path="/account" element={withLayout(Account)} />
              <Route path="/payment/success" element={withLayout(PaymentSuccess)} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Toaster position="top-center" theme="dark" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
